// DEPRECATED: Use CompactProjectModal instead
import { CompactProjectModal } from './CompactProjectModal';

interface NewProjectFormProps {
  onClose: () => void;
  onProjectCreated: (projectId: string) => Promise<void>;
}

export const NewProjectForm: React.FC<NewProjectFormProps> = ({
  onClose,
  onProjectCreated
}) => {
  // Use the new CompactProjectModal component
  return (
    <CompactProjectModal
      onClose={onClose}
      onProjectCreated={onProjectCreated}
    />
  );
};